import { render } from "./PartCategories.vue?vue&type=template&id=2576b5a5"
import script from "./PartCategories.vue?vue&type=script&lang=js"
export * from "./PartCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__